import { useState, useEffect, Fragment } from 'react';
import { useParams, useNavigate} from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import DatosCabezaFamilia from '../DatosCabezaFamilia.jsx';
import apiService from '../../../Auth/apiService.jsx';
import SweetAlert2 from 'react-sweetalert2';
import 'react-datepicker/dist/react-datepicker.css';
import MenuCaracterizacion from '../Componentes/MenuCaracterizacion.jsx';
import { useAuth } from '../../../Auth/AuthContext.jsx';
import SeccionPageHeader from '../../Utils/SeccionPageHeader.jsx';
import CargandoSpinner from '../../Utils/CargandoSpinner.jsx';
import { Card, CardBody, CardHeader } from 'react-bootstrap';


export default function ListarAtencionesPsicosociales(){
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const [expandedMap, setExpandedMap] = useState({});
    const { idCabezaFamilia } = useParams();
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
            nombre: '',
            cab_idcabezafamilia: '',
            cab_direccion: '',
            telefono: '',
            cab_celular: '',
            cab_correoelectronico: '',
        cab_nodeclaracion: ''
          });
    const [atenciones, setAtenciones] = useState([]);
    
    const DescargarArchivo = async (filename) => {
        if (!filename) return;
        setCargando(true);
                
        try {
            const response = await apiService.getFile('/reparacion/descargararchivo', { nombreArchivo: filename }, token);
            if(response.status === 200){
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.download = `${filename}`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
        } catch (err) {
            Mensaje('Descargar archivo', `Hubo un error al descargar el archivo ${filename}: ${err}`);
        } finally {
            setCargando(false);
        }
    };
    useEffect(() => {
        const fetchData = async () => {
            let url = '/reparacion/listaratencionespsicosociales';
            let obj = {idCabezaFamilia: idCabezaFamilia}
            try {
                setCargando(true);
                const response = await apiService.post(url, obj, token);
                const result = await response.data;
                setAtenciones(result.atenciones);
                setCabezaFamiliaDatos(result.cabezafamilia);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
        };

        fetchData();
    }, [idCabezaFamilia, token]);

    function formatFecha(fecha){
        if(!fecha) return '';
        try{
            const d = new Date(fecha);
            const y = d.getFullYear();
            const m = String(d.getMonth()+1).padStart(2,'0');
            const day = String(d.getDate()).padStart(2,'0');
            return `${y}-${m}-${day}`;
        }catch(e){
            return fecha;
        }
    }
    
    return (
        <div className="content-wrapper">
            <SeccionPageHeader title="Listar atenciones psicosociales" idCabezaFamilia={idCabezaFamilia} url={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} nombreurl="Grupo familiar" nombreform="Listar atenciones" />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia} />
                    <DatosCabezaFamilia datos={CabezaFamiliaDatos}></DatosCabezaFamilia>
                    <div className="row">
                        <div className="col-md-12">
                            <Card>
                                <CardHeader>
                                    <h3 className="card-title">Atenciones psicosociales registradas</h3>
                                </CardHeader>
                                <CardBody>
                                    {/* Tabla de atenciones */}
                                    {atenciones && atenciones.length > 0 ? (
                                        <div className="table-responsive">
                                            <table className="table table-striped table-sm">
                                                <thead>
                                                    <tr>
                                                        <th>Archivo</th>
                                                        <th>Estado</th>
                                                        <th>ID atención</th>
                                                        <th>Fecha</th>
                                                        <th>Tipo ayuda</th>
                                                        <th>Integrante</th>
                                                        <th>Entidad</th>
                                                        <th>Observaciones</th>
                                                        <th>Sede</th>
                                                        <th>Registró</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {atenciones.map((a, idx) => {
                                                        const id = a.id;
                                                        const rowKey = `${id}-${idx}`;
                                                        const expanded = !!expandedMap[rowKey];
                                                        return (
                                                            <Fragment key={rowKey}>
                                                                <tr style={{ cursor: 'pointer' }} onClick={() => setExpandedMap(s => ({ ...s, [rowKey]: !s[rowKey] }))}>
                                                                    <td>
                                                                        {a.archivoatencion ? (
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-link p-0"
                                                                                onClick={(e) => { e.stopPropagation(); DescargarArchivo(a.archivoatencion); }}
                                                                                aria-label={`Descargar ${a.archivoatencion}`}
                                                                            >
                                                                                {a.archivoatencion}
                                                                            </button>
                                                                        ) : (
                                                                            'Sin archivo'
                                                                        )}
                                                                    </td>
                                                                    <td>{a.atencioncerrada ? 'Cerrada' : 'Abierta'}</td>
                                                                    <td>{id}</td>
                                                                    <td>{formatFecha(a.fecha)}</td>
                                                                    <td>{a.tipoayuda}</td>
                                                                    <td>{a.integrante}</td>
                                                                    <td>{a.entidad}</td>
                                                                    <td>{a.observaciones}</td>
                                                                    <td>{a.sede}</td>
                                                                    <td>{a.usrnombre}</td>
                                                                </tr>
                                                                {expanded && (
                                                                    <tr className="table-active">
                                                                        <td colSpan={9}>{a.observacionpsicosocial || <em>No hay observación psicosocial</em>}</td>
                                                                    </tr>
                                                                )}
                                                            </Fragment>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <p className="mb-0">No hay atenciones registradas.</p>
                                    )}
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                </div>
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}